module.exports = __webpack_public_path__ + "img/web-cpaider-support.776bcb8f.svg";